import { useGlobalContext } from "@root/context";
import { useState } from "react";
import type { ISelectedObjective } from "../logics/types";

export const useModalObjectives = (
  onClose: () => void,
  onSubmit: (data: ISelectedObjective[]) => Promise<void> | void
) => {
  const [selectedOptions, setSelectedOptions] = useState<ISelectedObjective[]>([]);
  const { challenges } = useGlobalContext();

  const options: ISelectedObjective[] = challenges.flatMap((challenge) =>
    challenge.objectives
      .filter((objective) => objective.active)
      .map((objective) => ({
        challenge,
        objective,
      }))
  );

  const handleClose = () => {
    setSelectedOptions([]);
    onClose();
  };

  const handleSubmit = async () => {
    await onSubmit(selectedOptions);
    setSelectedOptions([]);
  };

  return {
    options,
    selectedOptions,
    setSelectedOptions,
    handleClose,
    handleSubmit,
  };
};
